import React from "react";
import type { ControlProps, OptionProps } from "react-select";
import { components } from "react-select";
import Select from "@/components/ui/Select";
import { countryList } from "./countries.constant";
import Avatar from "@/components/ui/Avatar/Avatar";
import CountryPhoneCustomSelectOption, {
  CountryOption,
} from "@/components/form/CountryPhoneCustomSelectOption";
import { ControllerRenderProps, FieldPath, FieldValues } from "react-hook-form";

const { Control } = components;

export default function CountrySelectionControlled<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(p: {
  appendNameToReturnValue?: boolean; // default false. If true, then the value returned is countryCode_countryName (e.g. "US_United States")
  field: ControllerRenderProps<TFieldValues, TName>;
}) {
  let wal;
  if (
    p.appendNameToReturnValue == true &&
    p.field.value &&
    p.field.value.includes("_")
  ) {
    const lookFor = p.field.value.split("_")[0];
    wal = countryList.filter((option) => option.value === lookFor);
  } else {
    wal = countryList.filter((option) => option.value === p.field.value);
  }
  console.log("wal=", wal);
  return (
    <Select<CountryOption>
      options={countryList}
      {...p.field}
      components={{
        Option: (props) => (
          <CountryPhoneCustomSelectOption
            variant="country"
            {...(props as OptionProps<CountryOption>)}
          />
        ),
        Control: ({ children, ...rest }) => (
          // @ts-expect-error F*ck I dont know
          <Control {...rest}>
            {rest.getValue()[0] && (
              <Avatar
                className="ltr:ml-4 rtl:mr-4"
                shape="circle"
                size={20}
                src={`/img/countries/${rest.getValue()[0].value}.png`}
              />
            )}
            {children}
          </Control>
        ),
      }}
      placeholder=""
      value={wal}
      onChange={(option) => {
        if (option == null) {
          p.field.onChange(undefined);
          return;
        }
        if (p.appendNameToReturnValue == true) {
          p.field.onChange(option.value + "_" + option.label);
        } else {
          p.field.onChange(option.value);
        }
      }}
    />
  );
}
